module.exports = __webpack_public_path__ + "static/img/home-banner.538d7415.jpg";